import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container _activity sub_page" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }
const _hoisted_4 = { class: "sub_page_con wrap_1120" }
const _hoisted_5 = { class: "bread_crumbs" }
const _hoisted_6 = { class: "sub_page_con_view con_write" }
const _hoisted_7 = { class: "report_con" }
const _hoisted_8 = { class: "con_form" }
const _hoisted_9 = { class: "file_wrap" }
const _hoisted_10 = { for: "area_file" }
const _hoisted_11 = { class: "file_list" }
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src", "onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "btn_wrap _default" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"deco_wrap\" data-v-6eafd0ba><i class=\"deco_01\" data-v-6eafd0ba><img src=\"img/activity_left.png\" data-v-6eafd0ba></i><i class=\"deco_02 _small blink4\" data-v-6eafd0ba><img src=\"img/b_icon_01.png\" data-v-6eafd0ba></i><i class=\"deco_03 _small blink_zoom1\" data-v-6eafd0ba><img src=\"img/b_icon_02.png\" data-v-6eafd0ba></i><i class=\"deco_04 _xxsmall blink_zoom4\" data-v-6eafd0ba><img src=\"img/b_icon_05.png\" data-v-6eafd0ba></i><i class=\"deco_05 none_768 spin2 _medium\" data-v-6eafd0ba><img src=\"img/b_icon_03.png\" data-v-6eafd0ba></i><i class=\"deco_06 none_768 spin_blink3 _small\" data-v-6eafd0ba><img src=\"img/b_icon_01.png\" data-v-6eafd0ba></i><i class=\"deco_07 none_768 blink_zoom4 _small\" data-v-6eafd0ba><img src=\"img/b_icon_02.png\" data-v-6eafd0ba></i><i class=\"deco_character\" data-v-6eafd0ba><img src=\"img/activity_icon.png\" data-v-6eafd0ba></i></div><div class=\"banner_wrap wrap_1120\" data-v-6eafd0ba><h2 data-v-6eafd0ba>시민참여 활동</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab(1))),
              class: _normalizeClass([$setup.state.tab === 1 ? 'active' : ''])
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "반성매매 시민활동", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab(2))),
              class: _normalizeClass([$setup.state.tab === 2 ? 'active' : ''])
            }, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "캠페인·이벤트", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab(3))),
              class: _normalizeClass([$setup.state.tab === 3 ? 'active' : ''])
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "참여하고 싶은 반성매매 활동 제안", -1)
            ]))], 2),
            ($setup.user.isLogin())
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeTab(4))),
                  class: _normalizeClass([[$setup.state.tab === 4 ? 'active' : ''], "w_1024_custom_width"])
                }, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("a", { href: "javascript:void(0)" }, "액션 시민 활동", -1)
                ]))], 2))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "icon_wrap"
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createElementVNode("img", {
                src: "img/home_icon.png",
                alt: "홈"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "참여하고 싶은 반성매매 활동 제안"
            })
          ], -1)),
          _createVNode(_component_router_link, { to: { path: '/board', query: { type: 3 } } }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("참여하고 싶은 반성매매 활동 제안", -1)
            ]))]),
            _: 1
          }),
          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "글쓰기"
            })
          ], -1)),
          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "faq_list_title" }, "글쓰기", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _cache[20] || (_cache[20] = _createElementVNode("label", {
                for: "title",
                class: ""
              }, "제목", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "title",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form_state.title) = $event)),
                type: "text",
                placeholder: "제목을 입력하세요"
              }, null, 512), [
                [_vModelText, $setup.form_state.title]
              ])
            ]),
            _createElementVNode("li", _hoisted_8, [
              _cache[21] || (_cache[21] = _createElementVNode("label", {
                for: "content",
                class: ""
              }, "내용", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "custom_scroll",
                id: "editor1",
                name: "editor1",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form_state.content) = $event))
              }, null, 512), [
                [_vModelText, $setup.form_state.content]
              ])
            ]),
            _createElementVNode("li", _hoisted_9, [
              _cache[29] || (_cache[29] = _createElementVNode("span", { class: "form_li_tit" }, "첨부", -1)),
              _createElementVNode("label", _hoisted_10, [
                _createElementVNode("input", {
                  id: "area_file",
                  type: "file",
                  placeholder: "",
                  accept: "image/*",
                  multiple: "",
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args)))
                }, null, 32),
                (!$setup.state.isMobile)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "file_box_wrap" }, "‘파일첨부’ 버튼을 클릭하여 첨부해주세요", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("span", {
                        class: "blue_btn",
                        style: {"display":"flex","justify-content":"center","align-items":"center"}
                      }, "파일첨부", -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[25] || (_cache[25] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1)),
                      _cache[26] || (_cache[26] = _createElementVNode("span", {
                        class: "blue_btn",
                        style: {"display":"flex","justify-content":"center","align-items":"center"}
                      }, "파일첨부", -1))
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form_state.file, (item, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "file",
                    key: idx
                  }, [
                    _createElementVNode("img", {
                      class: "file_item",
                      src: item.file,
                      alt: "",
                      onClick: ($event: any) => ($setup.showImgModal(item.file))
                    }, null, 8, _hoisted_12),
                    _createElementVNode("button", {
                      class: "file_del icon_wrap",
                      onClick: ($event: any) => ($setup.fileRemove(item.idx))
                    }, [...(_cache[27] || (_cache[27] = [
                      _createElementVNode("img", {
                        src: "img/close_02.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_13)
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.file, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "file",
                    key: index
                  }, [
                    _createElementVNode("img", {
                      class: "file_item",
                      src: $setup.CommonUtils.getImgUrl(item),
                      alt: "",
                      onClick: ($event: any) => ($setup.showImgModal($setup.CommonUtils.getImgUrl(item)))
                    }, null, 8, _hoisted_14),
                    _createElementVNode("button", {
                      class: "file_del icon_wrap",
                      onClick: ($event: any) => ($setup.removeNewFile(index))
                    }, [...(_cache[28] || (_cache[28] = [
                      _createElementVNode("img", {
                        src: "img/close_02.png",
                        alt: ""
                      }, null, -1)
                    ]))], 8, _hoisted_15)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "common_btn _gray w_180",
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.router.go(-1)))
          }, "취소"),
          _createElementVNode("button", {
            class: "common_btn w_180",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args)))
          }, "작성완료")
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}